import {io} from 'socket.io-client';
import {isInElectron, isWebClient} from './buildMode';

export const socket = io(process.env.REACT_APP_ORDERHUB_SOCKET_DOMAIN, {
// export const socket = io('https://api-dev.ishangry.com', {
	autoConnect: !isWebClient,
	path: isWebClient
		? (process.env.REACT_APP_FRESTO_SOCKET_PATH || '/pos/socket.io')
		: `${isInElectron ? '' : '/pos'}/socket.io`,
	transports: ['websocket'],
	auth: isWebClient ? {} : {token: process.env.REACT_APP_ORDERHUB_SOCKET_PASS ?? 'abcde'},
	reconnectionDelay: 5000,
});

export const connectOnlineSocket = token => {
	if (!isWebClient) return;
	socket.auth = {token};
	if (socket.connected) socket.disconnect();
	socket.connect();
};

export const disconnectOnlineSocket = () => {
	if (isWebClient) socket.disconnect();
};